import { rootApi } from "../rootApi";

export const dealerWarehouseApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    // List (paged)
    getWarehouses: builder.query({
      query: (params) => ({
        url: "v1/dealerwarehouse/dealer-warehouse-list",
        method: "GET",
        params
      }),
      // backend ResponseInfo<PagedResult<T>>
      transformResponse: (resp) => resp?.data ?? { rows: [], totalCount: 0, pageItemCount: 0 },
      providesTags: (result) =>
        result?.rows
          ? [
              ...result.rows.map((r) => ({ type: "DealerWarehouse", id: r.id })),
              { type: "DealerWarehouse", id: "LIST" }
            ]
          : [{ type: "DealerWarehouse", id: "LIST" }]
    }),

    // Create
    createWarehouse: builder.mutation({
      query: (payload) => ({
        url: "v1/dealerwarehouse/create-dealer-warehouse",
        method: "POST",
        body: payload,
        headers: { "Content-Type": "application/json" }
      }),
      invalidatesTags: [{ type: "DealerWarehouse", id: "LIST" }]
    }),

    // Update (PUT)
    updateWarehouse: builder.mutation({
      query: (payload) => ({
        url: "v1/dealerwarehouse/update-dealer-warehouse",
        method: "PUT",
        body: payload,
        headers: { "Content-Type": "application/json" }
      }),
      invalidatesTags: (r, e, arg) => [
        { type: "DealerWarehouse", id: arg?.id },
        { type: "DealerWarehouse", id: "LIST" }
      ]
    }),

    // Delete (soft)
    deleteWarehouse: builder.mutation({
      query: ({ id, appBranchId }) => ({
        url: "v1/dealerwarehouse/delete-dealer-warehouse",
        method: "DELETE",
        body: { id, appBranchId },
        headers: { "Content-Type": "application/json" }
      }),
      invalidatesTags: (r, e, arg) => [
        { type: "DealerWarehouse", id: arg?.id },
        { type: "DealerWarehouse", id: "LIST" }
      ]
    }),

    // Lookup: WAREHOUSE_TYPE
    getWarehouseTypes: builder.query({
      query: ({ languageId }) => ({
        url: "v1/lookup/get", 
        method: "GET",
        params: { groupCode: "WAREHOUSE_TYPE", languageId }
      }),
      transformResponse: (resp) => resp?.data ?? [],
      providesTags: [{ type: "Lookup", id: "WAREHOUSE_TYPE" }]
    }),

    // Parent dropdown (aktifler)
    getParentWarehouses: builder.query({
      query: ({ appBranchId, languageId }) => ({
        url: "v1/dealerwarehouse/dealer-warehouse-list",
        method: "GET",
        params: { appBranchId, languageId, pageNumber: 1, pageSize: 1000, isActive: 1 }
      }),
      transformResponse: (resp) => resp?.data?.rows ?? [],
      providesTags: [{ type: "DealerWarehouse", id: "LIST" }]
    })
  })
});

export const {
  useGetWarehousesQuery,
  useCreateWarehouseMutation,
  useUpdateWarehouseMutation,
  useDeleteWarehouseMutation,
  useGetWarehouseTypesQuery,
  useGetParentWarehousesQuery
} = dealerWarehouseApi;
